import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'resource#title_persona',
  type: 'persona',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
        grid: null,
      },
      {
        id: 'collection-related-graffiti',
        type: 'collection',
        title: 'resource#collection_related-graffiti',
        grid: 1,
      },
      
    ],
  },
} as ConfigMurucaResourceLayout;
